
import * as React from "react";
import styles from "./Columns.scss";

import { generateMarkup } from "../../helpers/generateMarkup";

type IProps = {
  content: Array<{
    title?: string;
    text: string;
  }>;
};

const Columns = (props: IProps) => {
  const columns = props.content;

  return columns ? <ul className={styles.clansInfoDescription}>
            {columns.map((column, index) => <li key={index} className={styles.clansInfoDescriptionItem}>
                    <div className={styles.clansInfoDescriptionTitle}>
                        {column.title || ''}
                    </div>
                    <div className={styles.blockContent}>
                        {generateMarkup(column.text)}
                    </div>
                </li>)}
        </ul> : null;
};

export default Columns;